import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ArrowRight, Send } from 'lucide-react';
export function CTASection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1200));
    setIsSubmitting(false);
    setSubmitted(true);
  };
  return <Section id="cta" background="dark" data-id="element-142">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-143">
        {/* Left: Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-144">
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-6 leading-tight" data-id="element-145">
            Let's Build Something Meaningful
          </h2>
          <p className="text-xl text-blue-200 mb-8 leading-relaxed" data-id="element-146">
            Have a project in mind or need guidance on your digital direction?
            Tell us about it - we'll get back to you in 2-4 hours.
          </p>
          <div className="space-y-4 text-blue-200 text-sm" data-id="element-147">
            <div className="flex items-center gap-3" data-id="element-148">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] shrink-0" data-id="element-149" />
              <span data-id="element-150">
                Strategy, design, and development - all under one roof
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-151">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] shrink-0" data-id="element-152" />
              <span data-id="element-153">Transparent process, clear timelines</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-154">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] shrink-0" data-id="element-155" />
              <span data-id="element-156">Long-term partnership, not just delivery</span>
            </div>
          </div>
        </motion.div>

        {/* Right: Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} data-id="element-157">
          {submitted ? <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 text-center border border-white/20" data-id="element-158">
              <div className="w-16 h-16 rounded-full bg-[#FF6600] flex items-center justify-center mx-auto mb-6" data-id="element-159">
                <Send className="w-7 h-7 text-white" data-id="element-160" />
              </div>
              <h3 className="text-2xl font-bold font-heading text-white mb-3" data-id="element-161">
                Message Sent!
              </h3>
              <p className="text-blue-200" data-id="element-162">
                Thanks for reaching out. We'll be in touch within 24 hours.
              </p>
            </motion.div> : <form onSubmit={handleSubmit} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 space-y-5" data-id="element-163">
              <div data-id="element-164">
                <label className="block text-sm font-medium text-blue-100 mb-2" data-id="element-165">
                  Your Name
                </label>
                <input type="text" name="name" required value={formData.name} onChange={handleChange} placeholder="Your Cute Name Here" className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-[#FF6600]/50 focus:border-[#FF6600] transition-colors" data-id="element-166" />
              </div>
              <div data-id="element-167">
                <label className="block text-sm font-medium text-blue-100 mb-2" data-id="element-168">
                  Email Address
                </label>
                <input type="email" name="email" required value={formData.email} onChange={handleChange} placeholder="Your Super Email Here" className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-[#FF6600]/50 focus:border-[#FF6600] transition-colors" data-id="element-169" />
              </div>
              <div data-id="element-170">
                <label className="block text-sm font-medium text-blue-100 mb-2" data-id="element-171">
                  Tell us about your project
                </label>
                <textarea name="message" required rows={4} value={formData.message} onChange={handleChange} placeholder="Describe your goals, timeline, and any details..." className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-[#FF6600]/50 focus:border-[#FF6600] transition-colors resize-none" data-id="element-172" />
              </div>
              <Button type="submit" size="lg" isLoading={isSubmitting} className="w-full bg-[#FF6600] text-white hover:bg-[#CC5200]" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-174" />} data-id="element-173">
                Send Message
              </Button>
            </form>}
        </motion.div>
      </div>
    </Section>;
}